import React from 'react';
import Layout from '../components/layout';
import './downloads.css';

export default function DownloadsPage() {
  return (
    <Layout subtitle="Downloads" className="smart-power-theater downloads">
      <h1>Commercial Products</h1>
      <hr style={{ marginTop: '0.825rem' }} />
      <div>
        <section>
          <h2>Metered Panelboard</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/brochure-power-metered-panelboard.pdf">
                Product Brochure
              </a>
            </li>
            <li>
              <a href="/downloads/dimensions-smart-panelboards.pdf">
                Panel Dimensions
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <section>
          <h2>Lighting Control Panel</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/brochure-breaker-control-panelboard.pdf">
                Product Brochure
              </a>
            </li>
            <li>
              <a href="/downloads/dimensions-smart-panelboards.pdf">
                Panel Dimensions
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <section>
          <h2>Retrofits</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/application-note-metered-panelboard.pdf">
                Application Note
              </a>
            </li>
            <li>
              <a href="/downloads/retrofit-panel-measurement-form.pdf">
                Worksheet
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <section>
          <h2>Metered Switchboard</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/brochure-power-metered-switchboard.pdf">
                Product Brochure
              </a>
            </li>
            <li>
              <a href="/downloads/specifications-power-metered-switchboard.pdf">
                Specifications
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <h1>Performance Lighting Products</h1>
        <hr style={{ marginTop: '0.825rem' }} />
        <section>
          <h2>Breaker Control Panel</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/bcp-product-sheet.pdf">Product Sheet</a>
            </li>
            <li>
              <a href="/downloads/bcp-configuration-guide.pdf">
                Configuration Guide
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <section>
          <h2>Smart Distro Panel</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/smart-distro-cut-sheet.pdf">Product Sheet</a>
            </li>
            <li>
              <a href="/downloads/smart-distro-configuration-guide.pdf">
                Configuration Guide
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <section>
          <h2>DMX Smart Contactor</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/smart-contactor-product-sheet.pdf">
                Product Sheet
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <section>
          <h2>RDM Integrity Software</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/rdm_integrity-product_sheet.pdf">
                Product Sheet
              </a>
            </li>
          </ul>
        </section>
        <hr />
        <h1>Horticulture Products</h1>
        <hr style={{ marginTop: '0.825rem' }} />
        <section>
          <h2>Power Metered Panel</h2>
          <ul style={{ listStyle: 'none' }}>
            <li>
              <a href="/downloads/horticulture-promo-sheet.pdf">Promo Sheet</a>
            </li>
          </ul>
        </section>
      </div>
    </Layout>
  );
}
